import { render, staticRenderFns } from "./Estrelas.vue?vue&type=template&id=b6f16a58&"
import script from "./Estrelas.vue?vue&type=script&lang=js&"
export * from "./Estrelas.vue?vue&type=script&lang=js&"
import style0 from "./Estrelas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports